<div
  [formGroup]="addressForm"
  class="form-group address-component"
  [class.address-component--inline]="!showAddressFields"
>
  <div class="form-group mt-3">
    <div
      class="d-flex justify-content-between"
      style="gap: 10px; flex-wrap: wrap"
    >
      <label for="" class="form-label"
        >Street Address
        <i *ngIf="isLoading" class="fa-spin fas fa-spinner ms-2"></i>
        <span
          *ngIf="isControlRequired(addressForm.controls['street_address'])"
          class="text-danger ms-2"
        >
          {{ showAddressFields ? "* (the address information is auto filled)" : "*" }}
        </span></label
      >
    </div>
    <div class="address-content">
      <p-autoComplete
        [disabled]="isLoading"
        [suggestions]="suggestions"
        (completeMethod)="onQueryChange($event)"
        field="label"
        (onSelect)="onSelected($event)"
        [formControlName]="'street_address'"
      ></p-autoComplete>
      <!-- <input type="text" [(ngModel)]="query" (input)="onQueryChange()" class="form-control" [formControlName]="'street_address'" autocomplete="off"> -->
    </div>
    <app-form-errors
      [color]="'danger'"
      [form]="addressForm"
      [control]="addressForm.controls['street_address']"
    >
    </app-form-errors>
  </div>
  <div *ngIf="showAddressFields" class="group">
    <div class="form-group country">
      <label for="" class="form-label"
        >Country
        <span
          *ngIf="isControlRequired(addressForm.controls['country'])"
          class="text-danger ms-2"
          >*</span
        ></label
      >
      <input
        type="text"
        [formControlName]="'country'"
        class="form-control"
        autocomplete="off"
      />
      <app-form-errors
        [color]="'danger'"
        [form]="addressForm"
        [control]="addressForm.controls['country']"
      >
      </app-form-errors>
    </div>
    <div class="form-group city">
      <label for="" class="form-label"
        >City
        <span
          *ngIf="isControlRequired(addressForm.controls['city'])"
          class="text-danger ms-2"
          >*</span
        ></label
      >
      <input
        type="text"
        class="form-control"
        [formControlName]="'city'"
        autocomplete="off"
      />
      <app-form-errors
        [color]="'danger'"
        [form]="addressForm"
        [control]="addressForm.controls['city']"
      >
      </app-form-errors>
    </div>
    <div class="form-group state">
      <label for="" class="form-label"
        >State
        <span
          *ngIf="isControlRequired(addressForm.controls['state'])"
          class="text-danger ms-2"
          >*</span
        ></label
      >
      <input
        type="text"
        class="form-control"
        [formControlName]="'state'"
        autocomplete="off"
      />
      <app-form-errors
        [color]="'danger'"
        [form]="addressForm"
        [control]="addressForm.controls['state']"
      >
      </app-form-errors>
    </div>
    <div class="form-group zip">
      <label for="" class="form-label"
        >Zip Code
        <span
          *ngIf="isControlRequired(addressForm.controls['zip_code'])"
          class="text-danger ms-2"
          >*</span
        ></label
      >
      <input
        type="text"
        class="form-control"
        autocomplete="off"
        numbersOnly
        formControlName="zip_code"
      />
      <!-- [maxlength]="5"
                [minlength]="5" -->
      <app-form-errors
        [color]="'danger'"
        [form]="addressForm"
        [control]="addressForm.controls['zip_code']"
      >
      </app-form-errors>
    </div>
  </div>
</div>
